import { WEBSITE_URL } from './config'

// The user menu, read by both the TopNavbar dropdown and the home page cards.
// An item links to a route (`route`) or out to the website (`href`, new tab).
// `label` is a list of i18n keys joined with a space. `title` and `visible` are
// optional; `visible` receives `{ role, currentUser }`. `home: false` keeps an item out of
// the home page cards, where it has a block of its own.

const isProcessGroupPointCompany = ({ role, currentUser }) =>
  !!(currentUser.companyId && role.processWithPoint)

const MENU = [
  {
    key: 'reports',
    title: 'title.myReports',
    items: [
      {
        route: 'reportScoreboard',
        icon: 'chart-pie',
        label: ['title.scoreboard'],
        description: 'home.cards.reportScoreboard'
      },
      {
        route: 'reportQuestionsAnswers',
        icon: 'list-ul',
        label: ['title.reportQuestionsAnswers'],
        description: 'home.cards.reportQuestionsAnswers'
      },
      {
        route: 'reportHistorical',
        icon: 'chart-bar',
        label: ['title.historicalScoreboard'],
        description: 'home.cards.reportHistorical'
      }
    ]
  },
  {
    key: 'company',
    title: 'title.company',
    visible: ({ role }) => !!role.company,
    items: [
      {
        route: 'reportCompanyScoreCompare',
        icon: 'chart-bar',
        label: ['title.scoreCompare'],
        description: 'home.cards.reportCompanyScoreCompare',
        visible: context => !isProcessGroupPointCompany(context)
      },
      {
        route: 'reportCompanyAnswerCompare',
        icon: 'chart-bar',
        label: ['title.answerCompare'],
        description: 'home.cards.reportCompanyAnswerCompare',
        visible: context => !isProcessGroupPointCompany(context)
      },
      {
        route: 'companyDepartment',
        icon: 'sitemap',
        label: ['title.department', 'title.edit'],
        description: 'home.cards.companyDepartment',
        visible: ({ role }) => !!role.companyDepartmentManagement
      }
    ]
  },
  {
    key: 'admin',
    title: 'title.admin',
    items: [
      {
        route: 'adminProcess',
        icon: 'edit',
        label: ['title.process', 'title.edit'],
        description: 'home.cards.adminProcess',
        visible: ({ role }) => !!(role.admin || role.companyProcessCreate)
      },
      {
        route: 'adminCompany',
        icon: 'building',
        label: ['title.company', 'title.edit'],
        description: 'home.cards.adminCompany',
        visible: ({ role }) => !!role.companyManagement
      },
      {
        route: 'adminUser',
        icon: 'users',
        label: ['title.adminUser'],
        description: 'home.cards.adminUser',
        visible: ({ role }) => !!role.admin
      },
      {
        route: 'adminDiscount',
        icon: 'money-check-alt',
        label: ['title.adminDiscount'],
        description: 'home.cards.adminDiscount',
        visible: ({ role }) => !!role.admin
      },
      {
        route: 'adminReportExport',
        icon: 'file-download',
        label: ['button.export'],
        description: 'home.cards.adminReportExport',
        visible: ({ role }) => !!role.admin
      }
    ]
  },
  {
    key: 'account',
    items: [
      {
        route: 'payment',
        icon: 'star',
        label: ['button.goToPaidMembership'],
        description: 'home.cards.payment',
        visible: ({ role }) => !!role.limited,
        home: false
      },
      {
        route: 'profile',
        icon: 'user',
        label: ['title.profile'],
        description: 'home.cards.profile'
      },
      {
        href: `${WEBSITE_URL}/yasal-bilgilendirmeler`,
        icon: 'balance-scale',
        label: ['title.legalInformation'],
        description: 'home.cards.legalInformation'
      },
      {
        href: WEBSITE_URL,
        icon: 'globe',
        label: ['title.websiteName'],
        description: 'home.cards.website'
      }
    ]
  }
]

const isVisible = (entry, context) => !entry.visible || entry.visible(context)

// The groups and items the user may see; groups left without items are dropped.
export function visibleMenu (context) {
  return MENU.filter(group => isVisible(group, context))
    .map(group => ({
      ...group,
      items: group.items.filter(item => isVisible(item, context))
    }))
    .filter(group => group.items.length > 0)
}

// The membership badge shown above the menu: its Buefy type and either an
// i18n key or a plain text (the company name).
export function membershipBadge ({ role, currentUser }) {
  if (role.admin) return { type: 'is-dark', label: 'title.admin' }
  if (currentUser.parentCompanyId) {
    return { type: 'is-info', text: currentUser.parentCompany }
  }
  if (role.company) return { type: 'is-info', text: currentUser.company }
  if (role.limited) return { type: 'is-warning', label: 'title.limited' }
  return { type: 'is-success', label: 'title.premiumSignup' }
}
